<template>
    <button
        class="bg-a-orange-fe5000 text-white rounded"
        :class="[btnClass]"
        :disabled="disabled"
    >
        <slot></slot>
    </button>
</template>
<script>
export default {
    name: "OrangeButton",
    props: {
        customClass: { type: String, default: null },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        btnClass: function() {
            if (this.customClass != null) {
                return this.customClass;
            }
            return "p-2";
        }
    }
};
</script>
